import { useState } from "react";
import "../css/invoiceDetails.css";
import { IoAdd, IoClose } from "react-icons/io5";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import CuInput from "../../all-patient/components/CuInput";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { useAtom } from "jotai";
import CuSuggestionBox from "../../common_component/component/CuSuggestionBox";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import CuDropdown from "../../common_component/component/CuDropdown";
import { TYPE } from "../../credit_invoice/constants/_constant";
import {
  calculateDiscountedPrice,
  validateDiscAmt,
} from "../../credit_invoice/helpers/_invoiceHelpers";
import { toast } from "react-toastify";
import {
  useCreateItem,
  useSecureUpdateItem,
} from "../../_helper/actions/mutation/items";

const InvoiceDetails = ({
  invoiceLines,
  setInvoiceLines,
  invoiceStatus,
  invoicePayload,
  setGetInvoiceId,
  setInvoicePayload,
}) => {
  const [isAddService, setIsAddService] = useState(false);
  const [serviceToggle, setServiceToggle] = useState(true);
  // const [isLineLevelDisc, setLineLevelDisc] = useState(false);
  const [clinic] = useAtom(clinicAtom);
  const [searchInput, setSearchInput] = useState({
    uom: "",
    name_of_service: "",
  });
  const [formData, setFormData] = useState({
    discount: "0",
    discount_type: "percentage",
    price: "0",
    type: "Amt",
    description: "",
    quantity: 1,
    sub_lines: [],
    uom: "",
    total: 0,
    line_service: null,
    line_package: null,
  });

  const handleServiceToggle = () => {
    setServiceToggle((prev) => !prev);
  };

  const handleAddService = () => {
    if (invoiceStatus !== "published") {
      setIsAddService(true);
    } else {
      toast.error("You can only do payment transactions in published invoices");
    }
  };

  const query = `?action=getClinicServices&fronted=True&clinic_id=${clinic?.id}&name_of_service=${searchInput?.name_of_service}`;

  const { data: services, isLoading: serviceLoading } = useItemsFilter(
    ApiEndPoint.CLINIC_SERVICES,
    query,
    clinic?.id && searchInput?.name_of_service?.length > 0 ? true : false
  );

  const { data: unitData, isLoading: unitLoading } = useItemsFilter(
    ApiEndPoint.CLINIC,
    `?action=getUnitsOfMeasure&clinic_id=${clinic?.id}&backend=True&name=${searchInput?.uom}`,
    clinic?.id && searchInput?.uom?.length > 0 ? true : false
  );

  const postInvoiceMutation = useCreateItem(
    ApiEndPoint.BILLING_CREDIT_INVOICE,
    ApiEndPoint.QM_SC_SLOTS
  );
  const updateInvoiceMutation = useSecureUpdateItem(
    ApiEndPoint.BILLING_CREDIT_INVOICE,
    ApiEndPoint.QM_SC_SLOTS
  );

  const handleSearch = (value, label) => {
    setSearchInput({
      uom: "",
      name_of_service: "",
      [label]: value,
    });
  };

  const clearSearch = () => {
    setSearchInput({ uom: "", name_of_service: "" });
  };

  const handleChange = (value, label) => {
    // if (label === "discount") {
    //   if (Number(value) < 0) {
    //     return;
    //   }
    //   const isValidate = validateDiscAmt(
    //     Number(formData?.price) * Number(formData?.quantity),
    //     value,
    //     formData?.discount_type
    //   );
    //   if (isValidate) {
    //     const discountedPrice = calculateDiscountedPrice(
    //       Number(formData?.price) * Number(formData?.quantity),
    //       value,
    //       formData?.discount_type
    //     );
    //     //(discountedPrice, value, "djsjalsk");
    //     setFormData((prev) => ({
    //       ...prev,
    //       discount: value,
    //       total: discountedPrice,
    //     }));
    //   }
    //   return;
    // }
    setFormData((prev) => ({ ...prev, [label]: value }));
  };

  const handleSelectOption = (obj, label) => {
    if (label === "description") {
      setFormData({
        discount: "0",
        discount_type: "percentage",
        price: obj?.price,
        type: "Amt",
        description: obj?.name_of_service,
        quantity: 1,
        sub_lines: [],
        uom: "",
        total: obj?.price,
        line_service: obj?.id,
        line_package: null,
      });
    }
    if (label === "uom") {
      setFormData((prev) => ({ ...prev, uom: obj?.name }));
    }
    clearSearch();
  };

  const handleDeleteService = (idx) => {
    if (invoiceStatus !== "published") {
      const updatedLines = [...invoiceLines];
      updatedLines.splice(idx, 1); // Remove the service at index
      const action = "patchBillingCreditInvoice";
      const totalInvoiceAmount = updatedLines.reduce(
        (acc, line) => acc + parseFloat(line.price || 0),
        0
      );

      let payload = {
        action,
        clinic_id: clinic?.id,
        id: invoicePayload?.id,
        invoice_lines: updatedLines, // Send updated lines to the server
        invoice_total: totalInvoiceAmount,
      };

      // //("PAYLOAD", payload);
      // Update the invoice on the server
      updateInvoiceMutation.mutate(
        { data: payload },
        {
          onSuccess: (data) => {
            // Update the local state after successful update
            setInvoiceLines(updatedLines);
            setInvoicePayload({
              ...invoicePayload,
              invoice_total: data?.data?.invoice_total,
            });

            toast.success("Service removed successfully.");
          },
          onError: () => {
            toast.error("Failed to remove the service. Please try again.");
          },
        }
      );
    } else {
      toast.error(
        "You can only do payment transactions in published invoices."
      );
    }
  };
  // const handleDeleteService = (idx) => {
  //   if (invoiceStatus !== "published") {
  //     setInvoiceLines((prev) => {
  //       const temp = [...prev];
  //       temp?.splice(idx, 1);
  //       return temp;
  //     });
  //   } else {
  //     toast.error("You can only do payment transactions in published invoices");
  //   }
  // };

  const handleSubmitService = (e) => {
    e.preventDefault();

    if (formData.description === "") {
      toast.error("Service cannot be empty!");
      return;
    }

    // Add the current form data to the invoiceLines
    setInvoiceLines((prev) => {
      const updatedInvoiceLines = [...prev, formData];

      // Calculate the total of all invoice lines by summing their prices
      const totalInvoiceAmount = updatedInvoiceLines.reduce(
        (acc, line) => acc + parseFloat(line.price || 0),
        0
      );

      // Call the appropriate function to post or patch the invoice after setting the invoice lines

      const action = invoicePayload?.id
        ? "patchBillingCreditInvoice"
        : "postBillingCreditInvoice";

      let payload = {
        action,
        clinic_id: clinic?.id,
        id: invoicePayload?.id,
        invoice_no: invoicePayload?.invoice_no,
        invoice_total: invoicePayload?.invoice_total,
        slot_id: invoicePayload?.slot_id,
        bill_type: "OPD",
        invoice_date: invoicePayload?.invoice_date,
        invoice_lines: updatedInvoiceLines,
        // billing_credit_payments,
        status: "draft",
        admission_details: {
          admission_date: "",
          admission_time: "",
          discharge_date: "",
          discharge_time: "",
          IPD_No: "",
          ipd_id: null,
          injury_no: "",
        },
        discount: invoicePayload?.discount,
        discount_type: invoicePayload?.discount_type,
        patient_details: invoicePayload?.patient_details?.id,
        feature_name: "invoice",
        invoice_total: totalInvoiceAmount,
        // pdf_payload,
      };
      // //(invoicePayload);

      // //(payload);

      // Perform the mutation based on the existence of invoiceId
      if (invoicePayload?.id) {
        updateInvoiceMutation.mutate(
          { data: payload },
          {
            onSuccess: (data) => {
              setGetInvoiceId(data?.data?.id);
              // setInvoicePayload({
              //   ...invoicePayload,
              //   invoice_total: data?.data?.invoice_total,
              // });
              toast.success("Service Added !");
              // Handle success, e.g., close the modal or refresh data
            },
            onError: (err) => {
              toast.error(
                err.response?.data?.error_msg || err.response?.data?.message
              );
            },
          }
        );
      } else {
        postInvoiceMutation.mutate(payload, {
          onSuccess: (data) => {
            // refetch();
            setGetInvoiceId(data?.data?.id);
            //("Service Added !", data);
            // setInvoicePayload({
            //   ...invoicePayload,
            //   invoice_total: totalInvoiceAmount,
            // });
            toast.success("Service Added !");
          },
          onError: (err) => {
            toast.error(
              err.response?.data?.error_msg || err.response?.data?.message
            );
          },
        });
      }

      return updatedInvoiceLines;
    });

    // Reset the form data
    setFormData({
      discount: "0",
      discount_type: "percentage",
      price: "0",
      type: "Amt",
      description: "",
      quantity: 1,
      sub_lines: [],
      uom: "",
      // total: 0,
      line_service: null,
      line_package: null,
    });

    setIsAddService(false);
  };

  return (
    <div className="w-full">
      <div>
        {invoiceLines?.map((line, idx) => {
          // //("Lines", line);
          return (
            <div
              className="flex justify-between items-center h-[48px] rounded-lg px-3 border"
              key={idx}
            >
              <div className="flex items-center gap-4 text-sm text-[#000000] text-[14px] leading-[28px]">
                <span>{line?.description}</span>
                <span>
                  ₹{" "}
                  {line?.description === "MEDICINE CHARGES"
                    ? line?.total
                    : line?.price}
                </span>
              </div>
              <IoClose
                size={19}
                color="#8D8D8D"
                className="cursor-pointer"
                onClick={() => handleDeleteService(idx)}
              />
            </div>
          );
        })}
      </div>
      {isAddService && (
        <div className="flex flex-col gap-5 mt-5">
          <div className="flex items-center justify-between">
            <span className="text-[#434343] text-[16px] font-bold">
              {formData?.description ? formData?.description : "Service Name"}
            </span>
            <span className="text-[#000000] text-[14px]">
              Rs {formData?.price}
            </span>
            <span onClick={handleServiceToggle}>
              {serviceToggle ? (
                <FaAngleUp size={20} className="cursor-pointer" />
              ) : (
                <FaAngleDown size={20} className="cursor-pointer" />
              )}
            </span>
          </div>
          {serviceToggle && (
            <>
              {/* <div className="flex justify-end gap-5">
                <input
                  type="checkbox"
                  checked={isLineLevelDisc}
                  onChange={() => setLineLevelDisc((prev) => !prev)}
                />
                <span className="text-[#000000] text-[14px]">
                  Line Level Discount
                </span>
              </div> */}
              <form
                className="flex flex-col gap-3"
                onSubmit={handleSubmitService}
              >
                <div>
                  <label>Type</label>
                  <CuDropdown
                    options={TYPE}
                    value={formData?.type}
                    onChange={(val) => handleChange(val, "type")}
                  />
                </div>
                <div>
                  <CuSuggestionBox
                    label="Service"
                    options={services}
                    renderKey={"name_of_service"}
                    value={formData?.description}
                    searchInput={searchInput?.name_of_service}
                    searchable
                    loading={serviceLoading}
                    setSearchInput={(value) =>
                      handleSearch(value, "name_of_service")
                    }
                    onChange={(val) => handleChange(val, "description")}
                    handleSelectOption={(obj) =>
                      handleSelectOption(obj, "description")
                    }
                  />
                </div>
                {formData?.type === "Qty" && (
                  <div>
                    <CuInput
                      label="Quantity"
                      type="number"
                      value={formData?.quantity}
                      onChange={(e) => handleChange(e.target.value, "quantity")}
                    />
                  </div>
                )}
                {formData?.type === "Qty" && (
                  <div>
                    <CuSuggestionBox
                      label="UOM"
                      options={unitData}
                      renderKey={"name"}
                      value={formData?.uom}
                      searchInput={searchInput?.uom}
                      searchable
                      loading={unitLoading}
                      setSearchInput={(value) => handleSearch(value, "uom")}
                      onChange={(val) => handleChange(val, "uom")}
                      handleSelectOption={(obj) =>
                        handleSelectOption(obj, "uom")
                      }
                    />
                  </div>
                )}
                <div>
                  <CuInput
                    label="Price"
                    type="number"
                    value={formData?.price}
                    onChange={(e) => handleChange(e.target.value, "price")}
                  />
                </div>
                {/* <div>
                  <CuInput
                    label="Discount"
                    type="number"
                    value={formData?.discount}
                    disabled={!isLineLevelDisc}
                    onChange={(e) => handleChange(e.target.value, "discount")}
                  />
                </div> */}
                <div className="flex justify-between items-center">
                  <div className="flex flex-col text-[#000000] items-center gap-1">
                    <span>INR</span>
                    <span className="text-[19px]">{formData?.total}</span>
                  </div>
                  <div>
                    <IoClose
                      color="red"
                      size={19}
                      className="cursor-pointer"
                      onClick={() => setIsAddService(false)}
                    />
                  </div>
                </div>
                <div>
                  <button className="cu-btn-gray" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </>
          )}
        </div>
      )}
      {!isAddService && (
        <div
          className="flex items-center gap-1 justify-center mt-4 cursor-pointer"
          onClick={handleAddService}
        >
          <span className="text-[#4B4B4B] text-[14px] font-bold">
            Add Services
          </span>
          <span>
            <IoAdd size={18} color="#4B4B4B" />
          </span>
        </div>
      )}
    </div>
  );
};

export default InvoiceDetails;
